import React from "react";
import { Link } from "react-router-dom";
import { services } from "../mock";
import {
  Building2, FileSignature, Landmark, HeartCrack, ShieldAlert, Briefcase,
  Users, IndianRupee, ShoppingBag, KeyRound, HardHat, Scale, Laptop, Copyright, FileText, Home, ArrowRight,
  Banknote, Car, Receipt
} from "lucide-react";

const iconMap = {
  Building2, FileSignature, Landmark, HeartCrack, ShieldAlert, Briefcase,
  Users, IndianRupee, ShoppingBag, KeyRound, HardHat, Scale, Laptop, Copyright, FileText, Home,
  Banknote, Car, Receipt
};

export default function ServicesSection() {
  return (
    <section id="services" className="py-24 bg-[#f7f2e8]/40">
      <div className="container-x">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-[#b28e42] uppercase tracking-[0.35em] text-xs font-semibold">Our Practice</span>
          <h2 className="font-serif-display text-4xl md:text-5xl text-[#0e1b34] mt-3 gold-underline center">
            Our Areas of Practice
          </h2>
          <p className="text-neutral-600 mt-6">
            Our multi-speciality law firm provides services across the following segments of the legal field.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {services.map((s) => {
            const Icon = iconMap[s.icon] || Scale;
            return (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                className="service-card group bg-white border border-neutral-200 rounded-sm p-7 flex flex-col"
              >
                <div className="service-icon-wrap w-14 h-14 rounded-sm bg-[#0e1b34]/5 text-[#0e1b34] flex items-center justify-center mb-5 transition-colors">
                  <Icon size={26} />
                </div>
                <h3 className="font-serif-display text-lg text-[#0e1b34] font-semibold mb-3 group-hover:text-[#b28e42] transition-colors">
                  {s.title}
                </h3>
                <p className="text-sm text-neutral-600 leading-relaxed flex-1">{s.short}</p>
                <div className="flex items-center gap-2 text-[#b28e42] text-xs font-semibold uppercase tracking-widest mt-5 group-hover:gap-3 transition-all">
                  Read More <ArrowRight size={13} />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
